import ActionType from '../constants/actionTypes'

export function resetBuilder() {
  return {
    type: ActionType.RESET_BUILDER
  }
}

export function updatePartLocation(id, x, y) {
  return {
    type: ActionType.UPDATE_PART_LOCATION,
    payload: { id, x, y }
  }
}

export function updatePartElementValue(partId, element, value) {
  return {
    type: ActionType.UPDATE_PART_ELEMENT_VALUE,
    payload: { partId, element, value }
  }
}



// WEBPACK FOOTER //
// ./client/modules/debate/actions/builder.js